export default {"src":"/_next/static/media/snorkel.6752bc90.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};